import { render } from "./fixed-participants.vue?vue&type=template&id=48aaea81&lang=pug"
import script from "./fixed-participants.vue?vue&type=script&lang=js"
export * from "./fixed-participants.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__